import { render, staticRenderFns } from "./AdminUserInfoButton.vue?vue&type=template&id=34f7ec4c&scoped=true&"
import script from "./AdminUserInfoButton.vue?vue&type=script&lang=ts&"
export * from "./AdminUserInfoButton.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUserInfoButton.vue?vue&type=style&index=0&id=34f7ec4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f7ec4c",
  null
  
)

export default component.exports
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerDots});
